import React from "react";
import PropTypes from "prop-types";
import { Copy } from "react-ikonate";
import styles from "./StoreProductItem.module.css";

/**
 * Right-hand action controls for a product row on the Store catalog page.
 * Rendered via the shared ProductCatalogBrowser's `renderItemActions` prop.
 */
export function StoreItemActions({ product, onEdit, onArchive, onDuplicate }) {
  // Archiving only makes sense for something that is actually live. Scheduled
  // and in-review products are taken off the store with the status
  // control instead, and an archived product is restored the same way — so the
  // row only carries the Archive button while the product is published, and
  // Edit takes the freed space rather than leaving a gap.
  const showArchive = product.status === "published";

  return (
    <div className={styles.actionRow}>
      <button
        type="button"
        className={styles.iconButton}
        aria-label="Duplicate product"
        onClick={() => onDuplicate(product)}
        title="Create an editable copy of this product as a new draft."
      >
        <Copy size={16} />
      </button>
      {showArchive && (
        <button
          type="button"
          className={styles.archiveButton}
          onClick={() => onArchive(product)}
          title="Archive this product so it no longer appears in the live store. You can restore it later."
        >
          Archive
        </button>
      )}
      <button
        type="button"
        className={`${styles.editButton}${
          showArchive ? "" : ` ${styles.editButtonWide}`
        }`}
        onClick={() => onEdit(product)}
        title="Open this product in the editor."
      >
        Edit
      </button>
    </div>
  );
}

StoreItemActions.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  onEdit: PropTypes.func,
  onArchive: PropTypes.func,
  onDuplicate: PropTypes.func,
};

StoreItemActions.defaultProps = {
  onEdit: () => {},
  onArchive: () => {},
  onDuplicate: () => {},
};

export default StoreItemActions;
